import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import enUS from 'antd/lib/locale/en_US';
import hrHR from 'antd/lib/locale/hr_HR';
import deDE from 'antd/lib/locale/de_DE';
import { APPLICATION_KEY, URL_PREFIX } from './utils/Constants';
import { NySettings, NyUtils } from '@nybble/nyreact';
import { ConfigProvider } from 'antd';
import './assets/styles/theme.less';
import 'moment/locale/de';

const localeMap: any = {
    'hr-HR': hrHR,
    'de-DE': deDE,
    'en-EN': enUS,
};

const root = () => {
    const storeValues = {
        applicationKey: APPLICATION_KEY,
        urlPreffix: URL_PREFIX,
        urlRefresh: '',
        urlLogin: '',
    };
    sessionStorage.setItem('NyReact', JSON.stringify(storeValues));

    const locale: any = NyUtils.getSelectedLocale();
    const antLocale: any = localeMap[locale] ? localeMap[locale] : enUS;

    ReactDOM.render(
        <React.StrictMode>
            <ConfigProvider locale={antLocale}>
                <App />
            </ConfigProvider>
        </React.StrictMode>,
        document.getElementById('root')
    );
};

root();
